import { useFetchInvoiceSettings } from "@sushicorp/services";
import Head from "next/head";
import React from "react";

import FourZeroFour from "components/fourZeroFour/FourZeroFour/FourZeroFour";
import TabsMenu from "components/global/TabsMenu/TabsMenu";
import ProfileBilling from "components/profileBilling/ProfileBilling/ProfileBilling";
import CONSTANTS from "config/constants";
import { notify } from "utils/common.utils";

const { TITLE } = CONSTANTS;

interface Props {}

const BillingPage = (props: Props) => {
  const { data: invoiceSettings, isFetching } = useFetchInvoiceSettings(notify);
  const { allowInvoicing } = invoiceSettings ?? {};

  if (!allowInvoicing && !isFetching) return <FourZeroFour />;

  return (
    <>
      <Head>
        <title>Facturación | {TITLE}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <ProfileBilling />
      </TabsMenu>
    </>
  );
};

export default BillingPage;
